import {useTranslation} from '.';
import {Time} from './time';

export const useTimeUnitTranslation = (type: 'long' | 'short' | 'shorter') => {
  const {t} = useTranslation();

  const long: {[key in keyof Time]: string} = {
    days: t('days'),
    hours: t('hours'),
    minutes: t('minutes'),
    seconds: t('seconds'),
  };

  const short: {[key in keyof Time]: string} = {
    days: t('days (abbreviated)'),
    hours: t('hours (abbreviated)'),
    minutes: t('minutes (abbreviated)'),
    seconds: t('seconds (abbreviated)'),
  };
  const shorter: {[key in keyof Time]: string} = {
    days: t('days (single letter)'),
    hours: t('hours (single letter)'),
    minutes: t('minutes (single letter)'),
    seconds: t('seconds (single letter)'),
  };

  switch (type) {
    case 'short':
      return short;
    case 'shorter':
      return shorter;
    case 'long':
    default:
      return long;
  }
};
